import { render } from "./Home.vue?vue&type=template&id=1e2f7a60&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=1e2f7a60&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2f7a60"]])

export default __exports__